import { useEffect, useState } from "react";
import Modal from "react-modal";
import "./index.css";
import { useOrder } from "../../hooks/useOrder";
import { useAppConfig } from "../../hooks/useAppConfig";
import { ConfigType } from "../../contexts/AppConfigContext";
import { StoreInfoSocialMedia } from "../StoreInfoSocialMedia/storeInfoSocialMedia";
import { MdInfoOutline } from "react-icons/md";
import { MdOutlineAttachMoney } from "react-icons/md";
import { FaRegStar, FaWhatsapp } from "react-icons/fa";
import api from "../../services/api";
import { usePluginspace } from "../../hooks/usePluginspace";

type RedeSocial = {
  id: number;
  name: string;
  url: string;
  type: string;
};
type ModalDeliveryProps = {
  isOpen: boolean;
  setIsOpen: (value: boolean) => void;
};

export function ModalInfoSeller({ isOpen, setIsOpen }: ModalDeliveryProps) {
  const { sellerInfo } = useOrder();
  const [config, setConfig] = useState<ConfigType | void>();
  const [redeSocial, setRedeSocial] = useState<RedeSocial[]>([]);
  const { getToken } = usePluginspace();
  const { getAppConfig } = useAppConfig();

  useEffect(() => {
    getConfig();
    getSocialMedia();
  }, []);

  async function getConfig() {
    const _config = await getAppConfig();
    setConfig(_config);
  }

  function whatsApp() {
    window.open(
      `https://wa.me/${sellerInfo?.numberPhone.replace(
        /[^0-9]/g,
        ""
      )}?text=${encodeURI("Gostaria de algumas informações")}`,
      "_blank",
      "noopener,noreferrer"
    );
  }

  async function getSocialMedia() {
    await api
      .get(
        `/api/socialnetwork`,

        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        }
      )
      .then(async (response) => {
        if (response.data && response.data.success) {
          setRedeSocial(response.data.data);
        } else {
          setRedeSocial([]);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={() => setIsOpen(false)}
      className="modal-info-seller"
      contentLabel="Endereço para entrega"
      overlayClassName="overlay-modal"
      ariaHideApp={false}
    >
      <div className="modal-info-seller-content">
        <div className="modal-infos-body-seller">
          <div className="title">
            <svg
              onClick={() => setIsOpen(false)}
              width="17"
              height="17"
              viewBox="0 0 17 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.978551 2.97126L6.957 8.94971L0.978551 14.9282L2.97137 16.921L8.94981 10.9425L14.9283 16.921L16.9211 14.9282L10.9426 8.94971L16.9211 2.97126L14.9283 0.978446L8.94981 6.95689L2.97137 0.978446L0.978551 2.97126Z"
                fill="#636363"
              />
            </svg>
          </div>
          <div className="description">
            {sellerInfo?.image &&
              sellerInfo.image != "default/default-user.jpg" && (
                <div className="seller-info-img">
                  <img src={sellerInfo.image} alt="" />
                </div>
              )}

            <div
              className="seller-info"
              style={{
                paddingLeft: `${
                  !(
                    sellerInfo?.image &&
                    sellerInfo.image != "default/default-user.jpg"
                  )
                    ? "4px"
                    : "0px"
                }`,
              }}
            >
              <span className="sellerName">{sellerInfo?.name}</span>
              <span className="text">
                Aproveite os benefícios de comprar com a minha ajuda!
              </span>
            </div>
          </div>
        </div>
        <div className="seller-cards">
          <div
            className="seller-card "
            style={{
              borderColor: config?.webappcolor.backgroundstatusactive,
              color: config?.webappcolor.backgroundstatusactive,
            }}
          >
            <MdInfoOutline size={24} />
            <span> Ajuda</span>
          </div>
          <div
            className="seller-card "
            style={{
              borderColor: config?.webappcolor.backgroundstatusactive,
              color: config?.webappcolor.backgroundstatusactive,
            }}
          >
            <MdOutlineAttachMoney size={26} />
            <span> Desconto</span>
          </div>
          <div
            className="seller-card "
            style={{
              borderColor: config?.webappcolor.backgroundstatusactive,
              color: config?.webappcolor.backgroundstatusactive,
            }}
          >
            <FaRegStar size={24} />
            <span> Novidades</span>
          </div>
        </div>
        <div className="seller-whatsapp">
          {sellerInfo?.numberPhone && (
            <button
              onClick={() => whatsApp()}
              className="button"
              style={{
                background: config?.webappcolor.backgroundstatusactive,
                color: "white",
              }}
            >
              <FaWhatsapp size={24} />
              <span> Entre em contato comigo</span>
            </button>
          )}
        </div>
        <StoreInfoSocialMedia redeSocial={redeSocial} />
      </div>
    </Modal>
  );
}
